var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useStateWithMutators } from '@rad/hooks';
import { withPromise } from '@rad/utility/promise';
import { SITE } from '../../utility/constants';
import { useScreen } from '../../utility/general';
import { postObjectJson } from '../../utility/request';
import BrandLogo from '../components/brand-logo';
import CInput from '../components/input';
// import CSelect from '../components/select'
import CErrors from '../components/errors';
export default (props) => {
    const screen = useScreen();
    const [state, mutators] = useStateWithMutators({
        'loading': false,
        'forms': {
            'login': {
                'error': null,
                'email': '',
                'password': '',
            },
            'context': {
                'kind': '',
                'id': '',
                'error': null,
            },
            'password': {
                'error': null,
                'email': '',
                'token': '',
                'password1': '',
                'password2': '',
            },
        },
        'error': '',
    });
    const withLoading = (f) => withPromise(() => mutators.loading(true), () => mutators.loading(false), f);
    const login = () => {
        withLoading(() => __awaiter(void 0, void 0, void 0, function* () {
            mutators.forms.login.error(null);
            yield postObjectJson('/login', state.forms.login, {
                'success': (json) => {
                    props.onLogin(json.token);
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () { return mutators.forms.login.error(yield res.json()); }),
            });
        }));
    };
    const selectContext = () => {
        withLoading(() => __awaiter(void 0, void 0, void 0, function* () {
            mutators.forms.context.error(null);
            yield postObjectJson('/login/context', state.forms.context, {
                'success': (json) => {
                    props.onLogin(json.token);
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () { return mutators.forms.login.error(yield res.json()); }),
            });
        }));
    };
    const passwordRequest = () => {
        withLoading(() => __awaiter(void 0, void 0, void 0, function* () {
            mutators.forms.password.error(null);
            yield postObjectJson('/password/request', Object.assign(Object.assign({}, state.forms.password), { 'site': SITE }), {
                'success': () => {
                    window.location.hash = '#/login/password-request/success';
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () { return mutators.forms.password.error(yield res.json()); }),
            });
        }));
    };
    const passwordChange = () => {
        withLoading(() => __awaiter(void 0, void 0, void 0, function* () {
            mutators.forms.password.error(null);
            const tokenFromUrl = screen.startsWith('#/login/password-change/') ? screen.substring('#/login/password-change/'.length) :
                screen.startsWith('#/login/password-choose/') ? screen.substring('#/login/password-choose/'.length) :
                    state.forms.password.token;
            yield postObjectJson('/password/change', {
                'token': tokenFromUrl,
                'password1': state.forms.password.password1,
                'password2': state.forms.password.password2,
            }, {
                'success': (json) => {
                    // Server now returns a JWT on success — auto-login like /login does.
                    // Fall back to the login screen if the response didn't include a token.
                    if (json && json.token) {
                        props.onLogin(json.token);
                    }
                    else {
                        window.location.hash = '#/login';
                    }
                },
                'error': (res) => __awaiter(void 0, void 0, void 0, function* () { return mutators.forms.password.error(yield res.json()); }),
            });
        }));
    };
    return _jsx(_Fragment, { children: _jsx("div", { className: "login-container brand-uat", children: _jsxs("div", { className: "login-box", children: [_jsx("div", { className: "logo-container", children: _jsx(BrandLogo, { className: "logo" }) }), _jsxs("p", { className: "brand-notice", children: [_jsx("strong", { children: "You're in the right place!" }), " Rate Remover Software has rebranded."] }), screen == '#/login/context' ?
                        _jsx("div", { children: _jsxs("form", { onSubmit: (e) => { e.preventDefault(); selectContext(); }, children: [_jsx("h3", { className: "heading", children: "Select Context" }), _jsx("div", { className: "text-center mb-2", children: _jsx("button", { type: "submit", className: "login-button", disabled: state.loading, children: state.loading ? 'Loading...' : 'Log In' }) }), _jsx("div", { className: "text-center", children: _jsx("a", { href: "#/login/password-request", className: "forgot-password", children: "Reset Password" }) })] }) })
                        : screen == '#/login/password-request' ?
                            _jsx("div", { children: _jsxs("form", { onSubmit: (e) => { e.preventDefault(); passwordRequest(); }, children: [_jsx("h3", { className: "heading", children: "Request Password" }), _jsx(CErrors, { errors: state.forms.password.error }), _jsx(CInput, { type: "text", value: state.forms.password.email, onChange: mutators.forms.password.email, children: "Email" }), _jsx("div", { className: "text-center mb-2", children: _jsx("button", { type: "submit", className: "login-button", disabled: state.loading, children: state.loading ? 'Loading...' : 'Submit' }) }), _jsx("div", { className: "text-center mt-3", children: _jsx("a", { href: "#/login", className: "forgot-password", children: "Cancel" }) })] }) })
                            : screen == '#/login/password-request/success' ?
                                _jsx("div", { children: _jsx("h3", { className: "heading", children: "A link to set your password has been sent to your email." }) })
                                : (screen.startsWith('#/login/password-change') || screen.startsWith('#/login/password-choose')) ?
                                    _jsx("div", { children: _jsxs("form", { onSubmit: (e) => { e.preventDefault(); passwordChange(); }, children: [_jsx("h3", { className: "heading", children: screen.startsWith('#/login/password-choose') ? 'Choose a Password' : 'Change Password' }), _jsx(CErrors, { errors: state.forms.password.error }), !screen.startsWith('#/login/password-change/') && !screen.startsWith('#/login/password-choose/') && _jsx(CInput, { type: "text", value: state.forms.password.token, onChange: mutators.forms.password.token, children: "Token" }), _jsx(CInput, { type: "password", value: state.forms.password.password1, onChange: mutators.forms.password.password1, children: "Password" }), _jsx(CInput, { type: "password", value: state.forms.password.password2, onChange: mutators.forms.password.password2, children: "Confirm Password" }), _jsx("div", { className: "text-center mb-2", children: _jsx("button", { type: "submit", className: "login-button", disabled: state.loading, children: state.loading ? 'Loading...' : 'Submit' }) })] }) })
                                    :
                                        _jsx("div", { children: _jsxs("form", { onSubmit: (e) => { e.preventDefault(); login(); }, children: [_jsx("h3", { className: "heading", children: "User Login" }), _jsx(CErrors, { errors: state.forms.login.error }), _jsx("div", { className: "mb-3", children: _jsx(CInput, { type: "text", value: state.forms.login.email, onChange: mutators.forms.login.email, children: "Email" }) }), _jsx("div", { className: "mb-3", children: _jsx(CInput, { type: "password", value: state.forms.login.password, onChange: mutators.forms.login.password, children: "Password" }) }), _jsx("div", { className: "login-button-container", children: _jsx("button", { type: "submit", className: "login-button", disabled: state.loading, children: state.loading ? 'Loading...' : 'Log In' }) }), _jsx("div", { className: "text-center mt-3", children: _jsx("a", { href: "#/login/password-request", className: "forgot-password", children: "Forgot Password?" }) }), _jsxs("div", { className: `text-center mt-3 signup-line`, children: ["Don't have an account? ", _jsx("a", { href: "#/onboarding", children: "Sign up" })] })] }) })] }) }) });
};
